import { render, staticRenderFns } from "./commonToast.vue?vue&type=template&id=0bcd9aa8&scoped=true"
import script from "./commonToast.vue?vue&type=script&lang=js"
export * from "./commonToast.vue?vue&type=script&lang=js"
import style0 from "./commonToast.vue?vue&type=style&index=0&id=0bcd9aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcd9aa8",
  null
  
)

export default component.exports